module.exports = __webpack_public_path__ + "static/media/shipping-truck-v2.b08ec73a.svg";